import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-show-organization-log',
  templateUrl: './show-organization-log.component.html',
  styleUrl: './show-organization-log.component.scss',
})
export class ShowOrganizationLogComponent {
  @Output() closeOn = new EventEmitter();
  showInfoPopup: boolean = false;
  data:
    | {
        createdAt: Date | string;
        createdBy: { firstName: string; lastName: string };
      }
    | undefined;

  initilize(data: {
    createdAt: Date | string;
    createdBy: { firstName: string; lastName: string };
  }) {
    this.data = data;
    this.showInfoPopup=true;
  }

  clearPopupInfos() {
    this.data = undefined;
    this.closeOn.emit();
  }
}
